import { connect } from 'react-redux';
import { setModalStandaloneClosed } from 'actions/modal-actions';
import { showTalpaGigyaModal } from 'actions/gigya-actions';
import { getUser } from 'store/reducers/user';

import TvConnectModal from './TvConnectModal';

const mapStateToProps = (state) => ({
  user: getUser(state),
});

const mapDispatchToProps = {
  onCloseModal: setModalStandaloneClosed,
  showTalpaGigyaModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(TvConnectModal);
